var boostPFSInstantSearchConfig = {
  search: {
    suggestionMobileStyle: "style2",
  },
};
!(function () {
  BoostPFS.inject(this),
    (SearchInput.prototype.customizeInstantSearch = function () {
      this.$uiMenuElement, this.$element, this.id;
    });

  /* Start of 80093*/
  InstantSearchResultItemProduct.prototype.getTemplate = function (tempType) {
    switch (tempType) {
      case InstantSearchResultItemProduct.tempType.IMAGE:
        return `
					  <div class="{{class.searchSuggestion}}-left">
						  <img src="{{imageUrl}}" alt="{{escapedTitle}}">
					  </div>
				  `;
      case InstantSearchResultItemProduct.tempType.SKU:
        return `
					  <p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
				  `;
      case InstantSearchResultItemProduct.tempType.VENDOR:
        return `
					  <div class="caption caption-large light {{class.searchSuggestion}}-product-vendor">{{vendor}}</div>
				  `;
      case InstantSearchResultItemProduct.tempType.PRICE:
        return `
					  <p class="{{class.searchSuggestion}}-product-price">
						  <span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
					  </p>
				  `;
      case InstantSearchResultItemProduct.tempType.PRICE_SALE:
        return `
					  <p class="{{class.searchSuggestion}}-product-price">
						  <s>{{compareAtPrice}}</s>
						  <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>
					  </p>
				  `;
      default:
        return `
					  <li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}">
						  <a href="{{url}}" {{newTabAttribute}}>
							  {{itemProductImage}}
							  <div class="{{class.searchSuggestion}}-right">
							  	  {{itemProductVendor}}
								  <p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
								  {{itemProductPrice}}
							  </div>
						  </a>
					  </li>
				  `;
    }
  };

  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
    if (this.isShow) {
      var searchTerm = Utils.escape(Globals.currentTerm);
      // Product image
      var imageHTML = "";
      if (
        Settings.getSettingValue("search.showSuggestionProductImage") &&
        this.imageUrl.length
      ) {
        imageHTML = this.getTemplate(
          InstantSearchResultItemProduct.tempType.IMAGE
        );
        imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
      }
      // Product title
      var productTitle = this.customizeProductTitle();
      productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
      // Vendor
      var vendorHTML = "";
      if (
        Settings.getSettingValue("search.showSuggestionProductVendor") &&
        this.vendor.length
      ) {
        vendorHTML = this.getTemplate(
          InstantSearchResultItemProduct.tempType.VENDOR
        );
        vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
      }
      // Price
      var priceHTML = this.compileSuggestionProductPrice();
      // Open the result item in new tab when selected
      var newTabAttr = Settings.getSettingValue("search.openProductNewTab")
        ? 'target="_blank"'
        : "";

      return this.getTemplate()
        .replace(/{{id}}/g, this.id)
        .replace(/{{escapedBlockType}}/g, Utils.escape(this.parent.type))
        .replace(/{{url}}/g, this.url)
        .replace(/{{newTabAttribute}}/g, newTabAttr)
        .replace(/{{itemProductImage}}/g, imageHTML)
        .replace(/{{title}}/g, productTitle)
        .replace(/{{escapedTitle}}/g, Utils.escape(productTitle))
        .replace(/{{itemProductVendor}}/g, vendorHTML)
        .replace(/{{itemProductPrice}}/, priceHTML)
        .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
        .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
        .replace(
          /{{class.searchUiAutocompleteItem}}/g,
          Class.searchUiAutocompleteItem
        );
    } else {
      return "";
    }
  };
  /*End of 80093*/
  // Start #223146
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice =
    function () {
      // If the multi-currency feature is enabled, update the product price
      this.prepareSuggestionProductPriceData();
      // Check on sale
      var onSale = this.data.compare_at_price_min > this.data.price_min;
      // Format price
      var price = Utils.formatMoney(this.data.price_min);
      var compareAtPrice = "";
      if (this.data && this.data.compare_at_price_min) {
        compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
        if (Settings.getSettingValue("search.removePriceDecimal")) {
          price = Utils.removeDecimal(price);
          compareAtPrice = Utils.removeDecimal(compareAtPrice);
        }
      }

      // Build Price
      var result = "";
      if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
        if (
          onSale &&
          Settings.getSettingValue("search.showSuggestionProductSalePrice")
        ) {
          result = this.getTemplate(
            InstantSearchResultItemProduct.tempType.PRICE_SALE
          );
        } else {
          result = this.getTemplate(
            InstantSearchResultItemProduct.tempType.PRICE
          );
        }
      }
      // Start boost #223146
      if (this.data.handle === "cadeaubon") {
        return '<div class="boost-pfs-variabel">Variabel</div>';
      }
      // End boost #223146
      return result
        .replace(/{{regularPrice}}/g, price)
        .replace(/{{compareAtPrice}}/g, compareAtPrice);
    };
  // End #223146
})();
